export const tr = {
    'day-budget': 'Ortalama günlük bütçe',
    'day-budget-custom': 'Belirli zaman aralığı için bütçe',
    'day-budget-off': 'kapalı',
    platform: 'Göster',
    settings: 'Ayarlar',
    strategy: 'Strateji'
};
